import React, { useRef } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

const AnotherMap = (props) => {
  const { latitude, longitude } = props.location;
  const ref = useRef();

  return (
    <div className="w-full h-full mx-5 rounded-lg overflow-hidden">
      <Map
        google={props.google}
        zoom={20}
        containerStyle={{
          position: "relative ",
          width: "100%",
          height: "500px",
        }}
        initialCenter={{ lat: latitude, lng: longitude }}
        center={{ lat: latitude, lng: longitude }}
      >
        <Marker
          ref={ref}
          name={"Current location"}
          position={{ lat: latitude, lng: longitude }}
        />
      </Map>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_APIKEY,
})(AnotherMap);
